import { useCallback, useEffect, useState,useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Image } from "primereact/image";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import BreadCrumbCustom from "../bread-crumb/bread-crumb";
import { BreadcrumbItem } from "../../interfaces/common/common";
import RouteConstant from "../../constants/route.constants";
import { Card } from "primereact/card";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import { useTranslation } from "react-i18next";
import UserAddressService from "../../services/useraddress/useraddress.service";
import GetAddressByLocation from "./location-search/get-location";
import { AdminUserAddress1, UserEditAddress1 } from "../../models/user-address-model";
import { CountryModel } from "../../models/country-model";
import { StateModel } from "../../models/state-model";
import { CityModel } from "../../models/city-model";
import RoleService from "../../services/role/role-service";
import { Toast, ToastMessage } from "primereact/toast";
import { number } from "yup";

const AddOrEditAddress = (props: any) => {
  const { id } = useParams();
  const isEdit: boolean = id !== "0";
  const [isLocationMapVisible, setIsLocationMapVisible] = useState(false);
  const [countries, setCountries] = useState<CountryModel[]>([]);
  const [cities, setCities] = useState<StateModel[]>([]);
  const [states, setStates] = useState<CityModel[]>([]);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);
  const [latLngSelected, setLatLngSelected] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [isPincodeSearched, setIsPincodeSearched] = useState(false);
  const toast = useRef<Toast>(null);
  const userId = props.userID;
  const isAdmin = RoleService.isAdmin();
  const [oldPincode,setOldPincode] = useState<any>();

  var navigate = useNavigate();
  const { t } = useTranslation();

  const showMessage = (
    label: string,
    message: string,
    severity: ToastMessage["severity"]
  ) => {
    toast.current?.show({
      severity: severity,
      summary: label,
      detail: message,
      life: 3000,
    });
  };
  const formik: any = useFormik({
    initialValues: {
      id: "",
      name: "",
      addressLine1: "",
      addressLine2: "",
      landMark: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
      areaId: "",
      subDistrictId : 0,
      districtId : 0,
      stateId : 0,
      countryId:0,
      sameAddressLine1: false
    },
    validate: (data: any) => {
      let errors: any = {};
      if (!data.addressLine1) {
        errors.addressLine1 = t("Address line1 is required");
      }
      if (!data.pincode) {
        errors.pincode = t("Pincode is required");
      } else if (isNaN(Number(data.pincode))) {
        errors.pincode = t("Pincode must be numeric");
      } else if (data.pincode.length < 3 || data.pincode.length > 6) {
        errors.pincode = t("Pincode must be 4 to 6 digits");
      }
      return errors;
    },
     onSubmit: async (data: any) => {
 
      const pincode = String(data.pincode || "").trim();
      if (areas.length > 1 && !data.areaId) {
        showMessage("Error", "Please select an area from the dropdown", "error");
        return;
      }
 
      if (!pincode) {
        showMessage("Error", "Please Enter Pincode", "error");
        return;
      }
 
      if (isNaN(Number(pincode))) {
        showMessage("Error", "Please enter a valid numeric pincode", "error");
        return;
      }
 
      if (pincode.length < 4 || pincode.length > 6) {
        showMessage("Error", "Pincode must be 4-6 digits", "error");
        return;
      }
      // if (!isPincodeSearched) {
      //   showMessage("Info", "Please verify pincode by clicking the search icon ", "info");
      //   return;
      // }
      let addressData: UserEditAddress1 = {
        userAddressID: data.id,
        address1: data.addressLine1,
        address2: data.addressLine2,
        landmark: data.landMark,
        zipcode: data.pincode,
        gpsLocation: latLngSelected,
        userID: userId,
        areaId: data.areaId !== "" && areas.length !== 1 ? data.areaId : areas[0].areaId,
      };
 
      let adminAddressData: AdminUserAddress1 = {
        userAddressID: data.id,
        address1: data.addressLine1,
        address2: data.addressLine2,
        landmark: data.landMark,
        zipcode: data.pincode,
        gpsLocation: latLngSelected,
        userID: userId,
        areaId: data.areaId !== "" && areas.length !== 1 ? data.areaId : areas[0].areaId,
      };
      setLoading(true);
 
      try {
        if (!isEdit) {
          const userAddress = await UserAddressService.addUserAddress(addressData);
          if (userAddress.isSuccess) {
            showMessage('Address Added', 'User address added successfully!', 'success');
            navigate('/user-addresses');
            window.location.reload();
 
          } else {
            showMessage('Error', 'Failed to add user address.', 'error');
          }
        } else {
          if (isAdmin) {
            const userAddress = await UserAddressService.addAdminAddress(adminAddressData);
            if (userAddress.isSuccess) {
              showMessage('Address Added', 'Admin address added successfully!', 'success');
              // props.setHideAddress(false);
              // props.RefreshQuery();
              window.location.reload();
 
            } else {
              showMessage('Error', 'Failed to add admin address.', 'error');
            }
            setTimeout(() => {
              props.setHideAddress(false);
            }, 1000);          
          } else {
            const updateSuccess = await UserAddressService.editUserAddress(addressData);
            if (updateSuccess.isSuccess) {
              showMessage('Address Updated', 'User address updated successfully!', 'success');
             // navigate('/user-addresses');
             navigate(RouteConstant.userAddresses);
            } else {
              showMessage('Error', 'Failed to update user address.', 'error');
            }
          }
        }
      } catch (error) {
        console.error(error);
        showMessage('Error', 'An unexpected error occurred. Please try again.', 'error');
      }
    }
  });
  const handlePincodeChange = (e: { target: { value: any; }; }) => {
    var newPincode = e.target.value;
    formik.handleChange(e);
 
    if (isEdit || newPincode !== formik.values.pincode) {
      setIsPincodeSearched(false);
      setAreas([]);
      setSubdistricts([]);
      setDistricts([]);
      setPinState([]);
      setPinCountry([]);
      setenabelDropdown(true);
      setOldPincode(newPincode);
      formik.setFieldValue("areaId", ""); 
    }

    if (newPincode.length === 6 && !isNaN(Number(newPincode))) {
      handleLocationFetch(parseInt(newPincode));
    } else if (newPincode.length > 6) {
      showMessage("Error", "Pincode must be 6 digits or less", "error");
    }
  };

  const updateLatitudeAndLongitude = (location: string) => {
    if (location) {
      try {
        var locationSplit = location.split(",");
        setLatitude(parseFloat(locationSplit[0]));
        setLongitude(parseFloat(locationSplit[1]));
        setLatLngSelected(location);
       
      } catch {

      }
    }
  }

  async function fetchData(addressId: number) {
    var userAddresses: any = await UserAddressService.getUserAddress(0);
    var userAddress: any = userAddresses.find((x: any) => x.userAddressID === addressId);
    if (userAddress) {
      let countryId: number = await getCountryIdByName(userAddress.countryName1);
      let stateId: number = await getStateIdByName(countryId, userAddress.stateName1);
      let cityId: number = await getCityIdByName(stateId, userAddress.cityName);
      FetchStates(countryId);
      FetchCities(stateId);
      UserAddressService.getCities(stateId).then(r => setCities(r));
      updateLatitudeAndLongitude(userAddress.gpsLocation);

      formik.setValues({
        id: userAddress.userAddressID,
        name: userAddress.userName,
        addressLine1: userAddress.address1,
        addressLine2: userAddress.address2,
        landMark: userAddress.landmark,
        country: countryId,
        state: stateId,
        city: cityId,
        pincode: userAddress.zipcode,
        areaId: formik.values.areaId,
        sameAddressLine1: userAddress.sameAddressLine1,
      });
    } else {
      if(!RoleService.isAdmin) {
        navigate(RouteConstant.userAddresses);
      } 
    }
  }

  useEffect(() => {
    UserAddressService.getCountries().then(r => setCountries(r));
    if (isEdit) {
      let addressId: number = id != null ? parseInt(id) : 0;
      fetchData(addressId);
      
    }
  }, []);
  const getCountryIdByName = async (countryName: string) => {
    try {
        if (!countryName || typeof countryName !== "string") {
            console.error("Invalid country name provided:", countryName);
            return null;
        }

        const trimmedCountryName = countryName.trim().toLowerCase().normalize("NFC");
        const countryList: any = await UserAddressService.getCountries();

        const country: any = countryList.find(
            (x: any) => typeof x.name === "string" && 
                        x.name.trim().toLowerCase().normalize("NFC") === trimmedCountryName
        );
       
        return country.countryID;

    } catch (error) {
        console.error("Error in getCountryIdByName:", error);
        return null;
    }
};

  const getStateIdByName = async (countryId: number, stateName: string) => {
    try {
      let stateList: any = await UserAddressService.getStates(countryId) || [];
      const state: any = stateList.find((x: any) => x.name.toLowerCase() === stateName.toLowerCase());
  
      return state.stateID;
    } catch (error) {
      console.error("Error in getStateIdByName:", error);
      return null;
    }
  };
  
  const getCityIdByName = async (stateId: number, cityName: string) => {
    try {
      const cityList: any = await UserAddressService.getCities(stateId);
     
      const city: any = cityList.find((x: any) => x.name.toLowerCase() === cityName.toLowerCase());
  
      return city.cityID;
    } catch (error) {
      console.error("Error in getCityIdByName:", error);
      return null;
    }
  };
  
  
  const FetchStates = (countryId: number) => {
    UserAddressService.getStates(countryId).then(r => setStates(r));
  };

  const FetchCities = (stateId: number) => {
    UserAddressService.getCities(stateId).then(r => setCities(r));
  };

  const isFormFieldInvalid = (name: any) => !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name: any) => {
    return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> : <small className="p-error">&nbsp;</small>;
  };

  const updateGpsLocation = useCallback(async (latLng: any) => {
    setIsLocationMapVisible(false);
    setLatLngSelected(latLng);
    updateLatitudeAndLongitude(latLng);
    if(isEdit && latLng && id != null){
      UserAddressService.updateGPSLocation(parseInt(id),latLng);
    }  
  }, []);       
   
  const breadCrumbItems: BreadcrumbItem = { items: [{ label: t("editaddress_breadcrumb_editaddress") }], home: { label: t("common_breadcrumb_home") }, backgroundImage: process.env.PUBLIC_URL + "/assests/images/image-1.jpeg", title: t("useraddress_breadcrumb_label")}   

  interface LocationDetails {
    areaId: string;
    areaName?: string;
    subDistrictsName?: string;
    districtName?: string;
    stateName?: string;
    countryName?: string;
  }
  const [locationDetails, setLocationDetails] = useState<LocationDetails[] | null>(null);
  const [areas, setAreas] = useState<{areaId:number;subDistrictId:number;areaName:string}[]>([]);
  const [subdistricts, setSubdistricts] = useState<{districtId:number,subDistrictId :number; subDistrictName : string}[]>([]);
  const [filterSubdistricts, setFilterSubdistricts] = useState<{districtId:number,subDistrictId :number; subDistrictName : string}[]>([]);
  const [districts, setDistricts] = useState<{districtId : number ; districtName : string}[]>([]);
  const [pinstate, setPinState] = useState<{stateId : number; stateName : string;districtId : number}[]>([]);
  const [pincountry, setPinCountry] = useState<{countryId : number ; countryName : string}[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const [enabelDropdown,setenabelDropdown] = useState<boolean>(true);
  const [filterDistricts, setFilterDistricts] = useState<{districtId : number ; districtName : string}[]>([]);
  const[filterStates,setfilterStates] = useState<{stateId : number; districtId : number ; stateName : string}[]>([]);
 
      const handleLocationFetch = async (pincode: number) => {
      try {
        setLoading(true);
        setSubdistricts([]);
        setFilterSubdistricts([]);
        var responsedData = await UserAddressService.getAddress(pincode);
       
        if (responsedData != null && responsedData.isSuccess) {
          if (!responsedData.areas || responsedData.areas.length === 0) {
            showMessage("Error", "This pincode does not exist in our records", "error");
            setIsPincodeSearched(false);
            setenabelDropdown(true);
            setLoading(false);
            return;
          }
          setAreas(responsedData.areas);
          setSubdistricts(responsedData.subDistricts);
          setFilterSubdistricts(responsedData.subDistricts);
          setDistricts(responsedData.districts);
          setFilterDistricts(responsedData.districts);
          setPinState(responsedData.states);
          setPinCountry(responsedData.countries);
          setfilterStates(responsedData.states);
          setenabelDropdown(false);
          setIsPincodeSearched(true);
         
          formik.setFieldValue("areaId", "");
         
          if (responsedData.areas.length === 1) {
            formik.setFieldValue("areaId", responsedData.areas[0].areaId);
          }
          setLoading(false);
        }
        else {
          setenabelDropdown(true);
          setLoading(false);
          showMessage("Error", responsedData?.message || "Please enter the valid pincode", "error");
        }
      } catch (error) {
        formik.setFieldError('pincode', t("editaddress_pin_code"));
        showMessage("Error", "Failed to fetch pincode details", "error");
        setLoading(false);
        return false;
      }
    };

 const  handelAreaChange = async (Id:any, value : any) => {
   formik.setFieldValue(Id,value);
   var SubdistcId = areas.filter(x => x.areaId === value)[0].subDistrictId;
   var filterdata = filterSubdistricts.filter(x  => x.subDistrictId === SubdistcId);
   var filterdat = filterDistricts.filter(x => x.districtId === filterdata[0].districtId);
   var filtersts = filterStates.filter(x => x.districtId === filterdat[0].districtId);

   setDistricts(filterdat);
   setSubdistricts(filterdata);
   setPinState(filtersts);

   formik.setFieldValue("subDistrictId", filterdata[0].subDistrictId);
   formik.setFieldValue("districtId", filterdat[0].districtId);
   formik.setFieldValue("stateId", pinstate[0].stateId);
   formik.setFieldValue("countryId", pincountry[0].countryId);
  }
 
  const handelsubdistc = async (Id:any) =>{
    formik.setFieldValue("subDistrictId", Id)
  }
 
  
  return (
    <>
    <Toast ref={toast} position="top-right" />
     {!isAdmin &&  <BreadCrumbCustom items={breadCrumbItems.items} home={breadCrumbItems.home} backgroundImage={breadCrumbItems.backgroundImage} title={breadCrumbItems.title} ></BreadCrumbCustom>}

      <div className={!isAdmin ? "container-fluid Address-form-container layout-content mt-3 mb-3":"container-fluid Address-form-container"}>
        <div className="col-12">
          {!isAdmin ?  <h5 className='mobile-txt-fnt mb-0'>
            <Link to={RouteConstant.userAddresses} className="history-title">
              <i className="pi pi-arrow-left"></i>
            </Link>
            &nbsp;&nbsp;&nbsp;&nbsp; {isEdit ? t('editaddress_edit_address') : t('editaddress_add_address')}
          </h5> : <h5 className="border-round order-top-color p-2">{t('editaddress_add_address')}</h5>}         
        </div>

        <div className="flex flex-column md:flex-row">
          <div className={`${isAdmin? "col-12": "col-9"}`}>
            <Card className="user-address-card border-1 surface-border m-0">
              <form onSubmit={formik.handleSubmit} className="flex flex-column">

                <div className="p-fluid formgrid grid">

                  <div className="field col-12 ">
                    <label htmlFor="addressLine1" className="label-semi-bold">{t('editaddress_address_line_1')}<span className="required">*</span></label>
                    <span className="p-input-icon-left">
                      <i className="pi pi-home text-area-icon" />
                      <InputTextarea placeholder={t('editaddress_please_enter_address_line1')} rows={2} name="addressLine1" id="addressLine1" value={formik.values.addressLine1}
                        onChange={formik.handleChange} className={classNames({ 'p-invalid': formik.errors.addressLine1 })}
                      />
                    </span>
                    {getFormErrorMessage('addressLine1')}
                  </div>

                  <div className="field col-12 ">
                    <label htmlFor="addressLine2" className="label-semi-bold">{t('editaddress_address_line_2')}</label>
                    <span className="p-input-icon-left">
                      <i className="pi pi-home text-area-icon" />
                      <InputTextarea placeholder={t('editaddress_please_enter_address_line2')} rows={2} name="addressLine2" id="addressLine2" value={formik.values.addressLine2}
                        onChange={formik.handleChange} className={classNames({ 'p-invalid': formik.errors.addressLine2 })}
                      />
                    </span>
                    {getFormErrorMessage('addressLine2')}
                  </div>

                  <div className="field col-12 ">
                    <label htmlFor="landMark1" className="label-semi-bold">{t('editaddress_land_mark')}</label>
                    <span className="p-input-icon-left">
                      <i className="pi pi-home text-area-icon" />
                      <InputTextarea placeholder={t('editaddress_please_enter_land_mark')} value={formik.values.landMark || ""} rows={2} name="landMark" id="landMark"
                        onChange={formik.handleChange} className={classNames({ 'p-invalid': formik.errors.landMark })}
                      />
                    </span>
                    {getFormErrorMessage('editaddress_land_mark')}
                  </div>

                  <div className="grid col-9">
                    <div className="field col-12 md:col-12">
                      <label htmlFor="pincode">
                        {t("editaddress_pincode")}
                        <span className="required">*</span>
                      </label>
                      <div className="p-inputgroup">
                      <span className="p-input-icon-left">
                          <i className="pi pi-hashtag" />
                            <InputText
                              keyfilter="int"
                              name="pincode"
                              id="pincode"
                              placeholder={t("editaddress_please_enter_pincode")}
                              value={formik.values.pincode}
                              onChange={handlePincodeChange}
                              className={classNames({
                                "p-invalid": formik.errors.pincode,
                              })}
                              style={{ width: "100%" }}
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              maxLength={6}
                              pattern="\d*"
                            />
                        </span>  
                        <Button
                          icon="pi pi-search"
                          severity="success"
                          aria-label="Search"
                          style={{width:'45px', borderRadius:"3px"}}
                          onClick={(e) => {
                          e.preventDefault();
                          handleLocationFetch(parseInt(formik.values.pincode));
                          }}
                        />
                      </div>
                      {getFormErrorMessage("pincode")}

                    </div>
                  </div>


                  <div className="form-row" hidden={enabelDropdown}>
                  <div className="grid col-12">
                    <div className="col-12 md:col-4">
                      <label htmlFor="area" className="label-semi-bold">Area</label>
                      <Dropdown
                            value={areas.length === 1 ? areas[0].areaId : formik.values.areaId}
                            options={areas.map((area:any) => ({
                              label: area.areaName,
                              value: area.areaId,
                            }))}
                            onChange={(e) =>  
                              handelAreaChange("areaId", e.value)
                            }
                            placeholder="Select Area"
                            disabled={areas.length > 1 ? false : true}
                          />
                    </div>

                    <div className="col-12 md:col-4">
                      <label htmlFor="subdistrict" className="label-semi-bold">Subdistrict</label>
                      <Dropdown
                              value={subdistricts.length === 1 ? subdistricts[0].subDistrictId : formik.values.subdistrict                              
                              }
                              onChange={(e) => formik.setFieldValue("subdistrict", e.value)}
                              options={subdistricts.map((subdistrict) => ({
                                label: subdistrict.subDistrictName,
                                value: subdistrict.subDistrictId,
                              }))}
                              placeholder="Select SubDistrict"
                              disabled={true}
                            />         
                    </div>

                    <div className="col-12 md:col-4">
                      <label htmlFor="district" className="label-semi-bold">District</label>
                      <InputText value={districts.length === 1 ? districts[0].districtName :  formik.values.district} onChange={(e) => formik.setFieldValue("district", e.target.textContent)} disabled={districts.length > 1 ? false : true}/>  
                    </div>

{/* 2nd row */}
                    <div className="grid col-12 mt-3">
                    <div className="col-12 md:col-4">
                    <label htmlFor="state" className="label-semi-bold">
                            State
                          </label>
                          <InputText value={pinstate.length === 1 ? pinstate[0].stateName :  formik.values.selectedState} onChange={(e) =>
                          formik.setFieldValue("state1", e.target.value)} disabled={pinstate.length > 1 ? false : true}/>
                    </div>

                    <div className="col-12 md:col-4">
                    <label htmlFor="country" className="label-semi-bold">
                            Country
                          </label>
                          <InputText value={pincountry.length === 1 ? pincountry[0].countryName : selectedCountry} onChange={(e) =>
                          formik.setFieldValue("country", e.target.value)} disabled={true}/>
                    </div>
                  </div>
                  </div>
                  </div>


                  <div className="col-12 flex justify-content-between">
                    {!isAdmin ? 
                    <div>
                      <Button
                        type="submit"
                        className="bg-primary"
                        label={isEdit ? t('common_update_button') : t('common_add_button')}
                        severity="success"
                      />
                    </div> :   <Button
                        type="submit"
                        className="bg-primary w-11rem"
                        label={t('common_add_button')}
                        severity="success"
                      />}
                  </div>

                </div>
              </form>
            </Card>
          </div>
          {!isAdmin &&  <div className="col-3 flex bg-light-green justify-content-center ">
            <Image width="150" src={process.env.PUBLIC_URL + '/assests/images/homelogo.png'} alt="Image" className="align-self-center align-items-center" />
          </div>}
         
        </div>
      </div>

      <Dialog
        header="Search your location"
        className='location-dialog'
        visible={isLocationMapVisible}
        onHide={() => setIsLocationMapVisible(false)}
        footer={""}
        style={{ width: "50%" }}
      >
        <GetAddressByLocation getLatitudeLongitude={updateGpsLocation} lat={latitude} lng={longitude}></GetAddressByLocation>
      </Dialog>
    </>
  );
};

export default AddOrEditAddress;
